
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { getOrderDetail, getOrderDetailByOrderSn, printDeliveryorder, updateShippingAddress} from '@/api/sms/shopify-order';
import { wait } from '@/utils/wait';
import { Message } from 'element-ui';

export default extend(dialog, {
	namespaced: true,
	state: {
		id: 0,
		orderSn: 0,
		type: 'id',
		detail: {},
		form: {}
	},
	actions: {
		async afterOpenDialog({ dispatch, commit, state }, payload) {
			const { id, orderSn, type } = state;
			await wait(dispatch, 'sms.forwarding-order.detail', async function () {
				let response = null;
				if (type === 'orderSn') {
					response = await getOrderDetailByOrderSn(orderSn);
				} else {
					response = await getOrderDetail(id);
				}
				if (response.data) {
					commit('save', {
						detail: response.data,
						form: {
							cartonNumber: response.data.cartonNumber,
							packageWeight: response.data.packageWeight
						}
					})
				} else {
					Message.error({
						message: '无此订单',
						onClose: () => {
							dispatch('closeDialog')
						}
					})
				}
			})
		},
		async confirm({ dispatch, commit, state }, payload) {
			const { detail, form } = state;
			await wait(dispatch, 'sms.shopify-order.confirm', async function () {
				const response = await updateShippingAddress({
					orderSn: detail.orderSn,
					...form
				});
				if (response.data) {
					Message.success('保存成功');
					dispatch('closeDialog');
					dispatch('smsShopifyOrder/getList', {}, { root: true });
				}
			})
		},
		async printDeliveryorder({ state, dispatch }, payload) {
			await wait(dispatch, `sms.forwarding-order.createPrint`, async function () {
				const response = await printDeliveryorder(payload);
				if (response.data) {
					window.open(response.data)
				}
			})
		},
		// // 到仓签收
		// async getScanning({ state, dispatch }, payload) {
		// 	await wait(dispatch, `sms.scanning.list`, async function () {
		// 		const response = await orderReceived(payload);
		// 		console.log(response)
		// 		if (response.data) {
		// 			console.log(response.data)
		// 		}
		// 	})
		// },
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/shopify-order/detail.js